import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { SelectorModel } from "../../../model/shared/selector.model";
import { environment } from "../../../../environments/environment";
import { apiLink } from "../../../constant/api-link";
import { CheckProvinceSelectorModel } from "../../../model/shared/check-province-selector.model";

@Injectable({
  providedIn: "root"
})
export class AddressService {

  constructor(
    private http: HttpClient
  ) { }

  sub: any;

  getDistrict(provinceCode: string, language: string): Observable<Array<SelectorModel>>  {
    const url = `${environment.apiCartographerUrl}BuilkAddress/GetDistrictByProvinceCode?provinceCode=${provinceCode}&languageCode=${language}`;
    this.sub = this.http.get(url);

    return this.sub;
  }

  getProvince(countryCode: string, language: string): Observable<Array<SelectorModel>> {
    const url = `${environment.apiCartographerUrl}subdivisions/${countryCode}/${language}`;
    this.sub = this.http.get(url);

    return this.sub;
  }

  getCountry(language: string): Observable<Array<SelectorModel>> {
    const url = `${environment.apiCartographerUrl}V2/divisions/${language}`;
    this.sub = this.http.get(url);

    return this.sub;
  }

  getCompanyCountries(): Observable<Array<string>> {
    const url = `${environment.apiBuilkURL}api/V2/BackOffice/GetCountry`;
    this.sub = this.http.get<Array<string>>(url);
    return this.sub;
  }

  checkProvince(code: string): Observable<CheckProvinceSelectorModel> {
    const url = `${environment.apiCartographerUrl}BuilkAddress/GetProvinceCodeFromName?provinceName=${code}`;
    this.sub = this.http.get(url);

    return this.sub;
  }
}
